import { MeshFactory } from '../factory/meshFactory.js';
import { spawnJungleCampsFromConfigs } from './matchMapApplyController.js';
import { mapAllowsTrainingExtras } from './mapSandboxExtras.js';

/**
 * bootSandboxPropGroups — Decorative bushes/mountain for test_map only.
 */
export function bootSandboxPropGroups(scene) {
  const bushA = MeshFactory.createBushMesh(5, 0.75, 5, 2.2);
  const bushB = MeshFactory.createBushMesh(6, 0.75, -4, 2.8);
  const mountain = MeshFactory.createMountainMesh(-6, 0);
  scene.add(bushA);
  scene.add(bushB);
  scene.add(mountain);
  return [bushA, bushB, mountain];
}

/**
 * createJungleSpawnHandler — Gate jungle spawn by map (no camps on ARAM).
 */
export function createJungleSpawnHandler({
  getMapId,
  getLastPlanCamps,
  getMapConfigCamps,
  scene,
  hudUI,
  uiContainer,
  getActiveJungleCamps,
  setActiveJungleCamps
}) {
  return function spawnJungleCamps(campConfigs) {
    const mapId = getMapId();
    if (!mapAllowsTrainingExtras(mapId)) {
      spawnJungleCampsFromConfigs({
        camps: [],
        scene,
        hudUI,
        uiContainer,
        getActive: getActiveJungleCamps,
        setActive: setActiveJungleCamps
      });
      return;
    }
    const camps = campConfigs
      || getLastPlanCamps()
      || getMapConfigCamps()
      || [];
    spawnJungleCampsFromConfigs({
      camps,
      scene,
      hudUI,
      uiContainer,
      getActive: getActiveJungleCamps,
      setActive: setActiveJungleCamps
    });
  };
}
